import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../../ValueWithRandom";
export var PathDelay = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(PathDelay, _ValueWithRandom);
  var _super = _createSuper(PathDelay);
  function PathDelay() {
    _classCallCheck(this, PathDelay);
    return _super.call(this);
  }
  return _createClass(PathDelay);
}(ValueWithRandom);